import { render, staticRenderFns } from "./navItem.vue?vue&type=template&id=b3012c64&scoped=true&"
import script from "./navItem.vue?vue&type=script&lang=js&"
export * from "./navItem.vue?vue&type=script&lang=js&"
import style0 from "./navItem.vue?vue&type=style&index=0&id=b3012c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3012c64",
  null
  
)

export default component.exports